/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsBasicModelResponse } from './RevisdomAPIViewModelsBasicModelResponse';
import {
    RevisdomAPIViewModelsBasicModelResponseFromJSON,
    RevisdomAPIViewModelsBasicModelResponseFromJSONTyped,
    RevisdomAPIViewModelsBasicModelResponseToJSON,
    RevisdomAPIViewModelsBasicModelResponseToJSONTyped,
} from './RevisdomAPIViewModelsBasicModelResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1IEnumerable1
 */
export interface ApiResponse1IEnumerable1 {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1IEnumerable1
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1IEnumerable1
     */
    message?: string | null;
    /**
     * Response data'sı
     * @type {Array<RevisdomAPIViewModelsBasicModelResponse>}
     * @memberof ApiResponse1IEnumerable1
     */
    data?: Array<RevisdomAPIViewModelsBasicModelResponse> | null;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1IEnumerable1
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1IEnumerable1 interface.
 */
export function instanceOfApiResponse1IEnumerable1(value: object): value is ApiResponse1IEnumerable1 {
    return true;
}

export function ApiResponse1IEnumerable1FromJSON(json: any): ApiResponse1IEnumerable1 {
    return ApiResponse1IEnumerable1FromJSONTyped(json, false);
}

export function ApiResponse1IEnumerable1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1IEnumerable1 {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(RevisdomAPIViewModelsBasicModelResponseFromJSON)),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1IEnumerable1ToJSON(json: any): ApiResponse1IEnumerable1 {
    return ApiResponse1IEnumerable1ToJSONTyped(json, false);
}

export function ApiResponse1IEnumerable1ToJSONTyped(value?: ApiResponse1IEnumerable1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(RevisdomAPIViewModelsBasicModelResponseToJSON)),
        'errors': value['errors'],
    };
}

